// import { footerType } from "@src/components/organisms/Footer";
import { pageConst } from "@src/constants/pageConst";
import { OnClickRouting } from "@src/libs/event/OnClickRouting";
import { useRouter } from "next/router";

/**
 * フッター用injector
 * @returns {footerType}
 * @constructor
 */
export function FooterInjector(): any {
  const router = useRouter();
  return {};
}
